import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import RevvedCircularProgress from './RevvedCircularProgress'

export default function SalesGoal(props) {

	const sales = props.user?.goals.find(x=> x.goal_type_id === '3')

	const useStyles = makeStyles(theme => ({
		salesGoalRoot: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-evenly',
			height: sales ? 'calc(100% - 3em)' : '8em'
		},
		bottom: {
			 color: 'grey',
		},
		top: {
			color:  '#ffd600',
			animationDuration: "550ms",
			position: "absolute",
			left: 0,
		},
		circle: {
			  strokeLinecap: "round",
			  transition: 'all 800ms ease-in',
		}
	}))

	const classes = useStyles()
	
	if (!sales?.goal) {
		return (
			<div className={classes.salesGoalRoot}>
				<Typography 
					variant="subtitle1"
					component="div"
					color="textSecondary"
					align="center"
				>
					You currently don’t have a sales goal, you can disable this widget in your profile or 
					see a system administrator to record an annual goal.
				</Typography>
			</div>
		)
	}

	return (

		<div className={classes.salesGoalRoot}>

			<Box position="relative" display="inline-flex" style={{
				padding: '3em 0'
			}}>
				<RevvedCircularProgress
					current={Math.min(
						sales?.progress,
						sales?.target
					)}
					target={sales?.target}
					textStyle={{ fontSize: 20 }}
					topColor="#E8DA2D"
					bottomColor="lightgrey"
					size={170}
					thickness={5}
				></RevvedCircularProgress>
			</Box> 
				
			<Box>
				<Typography 
					variant="subtitle1"
					component="div"
					color="textSecondary"
				>
					<table style={{width: '20em'}}>
						<tbody>
							<tr>
								<th></th>
								<th></th>
							</tr>
							<tr>
					    	<td style={{textAlign:'right'}}>Year to Date:</td>
								<td style={{paddingLeft:'2em'}}>$ {sales?.progress?.toLocaleString()}</td>
							</tr>
							<tr>
								<td style={{textAlign:'right'}}>Goal:</td>
								<td style={{paddingLeft:'2em'}}>$ {sales?.target?.toLocaleString()}</td>
							</tr>
						</tbody>
					</table>
					
				</Typography>
					
			</Box>

		</div>
	)

}
